export default function HawkishCut() {
    return (
      <article className="prose prose-invert max-w-3xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold tracking-tight mb-2">
          The Hawkish Cut
        </h1>
  
        <p>
          October 29. The Fed cut rates 25bp and ended QT. Both priced in. Surface
          read: dovish. Tape read: the opposite.
        </p>
  
        <p>
          Retail looks at the S&amp;P. The S&amp;P barely moved. Case closed right?
          Wrong. The signal was everywhere else.
        </p>
  
        <h2 className="text-2xl font-bold">What Actually Moved</h2>
        <ul>
          <li><strong>2-year yield</strong> ripped from ~3.4% to 3.6%.</li>
          <li><strong>Dollar</strong> strengthened to a three-month high.</li>
          <li><strong>Gold</strong> reversed $80 off the intraday high inside an hour.</li>
          <li><strong>December cut odds</strong> collapsed from 90% to 60%.</li>
        </ul>
  
        <p>
          That's a hawkish reaction to a dovish action. The cut was priced in. What
          wasn't priced in was Powell saying a December cut was "not a foregone
          conclusion" and flagging dissent on the committee.
        </p>
  
        <h2 className="text-2xl font-bold">Why It Happened</h2>
        <p>
          A Fed meeting has two signals — the decision and the language. Retail
          trades the decision. Pros trade the language. When they disagree the
          language wins every time because it sets the path forward.
        </p>
        <p>
          The cut was backward-looking. Powell's tone was forward-looking. Markets
          price the future not the present.
        </p>
    
        <p>
          You don't need to outpredict the Fed. You need to notice when the market
          is overconfident in one direction and position against it.
        </p>
  
        <h2 className="text-2xl font-bold">The Takeaway</h2>
        <p>
          Watch the 2-year yield. Watch the dollar. Watch gold. Equities move last
          and say least on Fed days. If you only check the S&amp;P you miss the
          entire meeting.
        </p>
        <p>Same event. Different read. Different outcome.</p>
      </article>
    );
  }